import { useState } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";

const useInsertDealPayment = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const insertDealPayment = async (dealId, amount) => {
        if (!dealId || !amount) {
            toast.error("Deal ID and amount are required.");
            return;
        }

        setLoading(true);
        setError(null);
        try {
            const response = await post({
                fn: "insertDealPayment",
                dealId: dealId,
                amount: amount,
            });
            toast.success("Payment added successfully");
            return response;
        } catch (err) {
            toast.error(err.response?.data?.text || "Failed to add payment");
            setError(err);
            throw err;
        } finally {
            setLoading(false);
        }
    };

    return { loading, error, insertDealPayment };
};

export default useInsertDealPayment;
